
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Calendar, Users, UserRound } from "lucide-react";
import { cn } from "@/lib/utils";
import { formatCurrency } from "@/lib/utils";

export interface PackageProps {
  title: string;
  price: number;
  description: string;
  days: number;
  hunters?: number;
  guides?: number;
  badgeText?: string;
  badgeColor?: string;
  isSelected?: boolean;
  onClick: () => void;
}

export const PackageCard: React.FC<PackageProps> = ({
  title,
  price,
  description,
  days,
  hunters,
  guides,
  badgeText,
  badgeColor = "bg-blue-500",
  isSelected = false,
  onClick,
}) => {
  return (
    <Card 
      className={cn(
        "cursor-pointer transition-all duration-200 hover:shadow-md border-2 h-full",
        isSelected 
          ? "border-tribal-primary bg-tribal-primary/5" 
          : "border-tribal-neutral/20 hover:border-tribal-primary/50"
      )}
      onClick={onClick}
    >
      <CardContent className="p-6">
        <div className="flex justify-between items-start mb-2">
          <h3 className="text-xl font-bold text-tribal-secondary">{title}</h3>
          {badgeText && (
            <Badge className={`${badgeColor} text-white border-0`}>
              {badgeText}
            </Badge>
          )}
        </div>
        
        <div className="text-tribal-primary font-bold text-xl mb-2">
          {formatCurrency(price)}
        </div>
        
        <p className="text-tribal-neutral mb-6 text-sm">{description}</p>
        
        <div className="flex flex-col space-y-2 text-tribal-neutral text-sm">
          <div className="flex items-center">
            <Calendar className="h-4 w-4 mr-2 text-tribal-primary" />
            {days} {days === 1 ? 'day' : 'days'}
          </div>
          
          {hunters && (
            <div className="flex items-center">
              <UserRound className="h-4 w-4 mr-2 text-tribal-primary" />
              {hunters} {hunters === 1 ? 'hunter' : 'hunters'}
            </div>
          )}
          
          {guides && (
            <div className="flex items-center">
              <Users className="h-4 w-4 mr-2 text-tribal-primary" />
              {guides} {guides === 1 ? 'guide' : 'guides'}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
